module.exports = __webpack_public_path__ + "img/goal.6a66416c.jpg";